import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import getPvReportData, { PvReportData } from "../http/getPvReportData";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const usePvReportData = (siteId?: string, userOrgId?: string) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchPvReportData = useQuery(
    ["pv-report-data", siteId],
    async () => {
      return getPvReportData(
        await getAuthTokenBlocking(getToken, relogin),
        siteId!,
        userOrgId
      );
    },
    {
      enabled: !!siteId,
      staleTime: 5 * 60 * 1000,
    }
  );

  return { fetchPvReportData };
};

export default usePvReportData;
export type { PvReportData };
